import type { PropsWithChildren } from 'react'
import { createContext } from 'react'

const FlightsLoyaltyContext = createContext<boolean>(true)

interface Props {
  showLoyaltyPoints: boolean
}

export function FlightsLoyaltyProvider(props: PropsWithChildren<Props>) {
  const { showLoyaltyPoints } = props

  return <FlightsLoyaltyContext.Provider value={showLoyaltyPoints}>
    {props.children}
  </FlightsLoyaltyContext.Provider>
}

export default FlightsLoyaltyContext
